// UI texts of the entry draft feature, kept apart from the JSX so they can be
// replaced by a localization library later.
export const ENTRY_DRAFT_MESSAGES = {
  draftAvailable: 'Восстановлены последние неопубликованные изменения этой записи',
  // on its own line under draftAvailable; `ago` is a relative time like
  // "3 дня назад", missing on old drafts
  draftSavedAgo: (ago: string) => `(${ago})`,
  restoreOriginal: 'Отменить неопубликованные изменения',
  originalRestored: 'Изменения отменены',
  undoRestore: 'Вернуть последнее редактирование',
  close: 'Закрыть'
};
